import { createSelector } from 'reselect';

const getCreateMode = (state) => state.sceneConfiguration.showForm;

const getShowForm = createSelector([getCreateMode], (isCreate) => isCreate);

export default getShowForm;
